import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import cx from "classnames"

export interface HorizontalIconCardProps {
  icon: IconDefinition
  heading: string
  text: string
  className?: string
}

const HorizontalIconCard = ({
  icon,
  heading,
  text,
  className,
}: HorizontalIconCardProps) => (
  <div
    className={cx("flex gap-3", className)}
    data-testid="horizontal-icon-card"
  >
    <div className="w-[54px] h-[54px] flex items-center justify-center shrink-0">
      <FontAwesomeIcon
        icon={icon}
        title={icon.iconName}
        className="pointer-events-none"
        style={{ fontSize: 36 }}
        color="#2D8052"
      />
    </div>

    <div>
      <h3 className="font-body font-bold leading-6 tracking-[0.96px]">
        {heading}
      </h3>

      <p className="font-body text-sm leading-[140%] tracking-[0.28px]">
        {text}
      </p>
    </div>
  </div>
)

export default HorizontalIconCard
